/**
 * Willow & Dove — Product Page JavaScript
 * Handles: gallery, zoom, variant selection, quantity, tabs, add to cart
 */

(function() {
  'use strict';

  // ── Wait for DOM ──────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', initProductPage);

  function initProductPage() {
    initGallery();
    initVariantSelector();
    initQuantityPicker();
    initTabs();
    initAddToCart();
    initRecommendations();
  }

  // ── Image Gallery ─────────────────────────────────────────────────────

  function initGallery() {
    var mainWrapper = document.getElementById('mainImageWrapper');
    var mainImage = document.getElementById('mainImage');
    var thumbStrip = document.getElementById('thumbStrip');

    if (!mainWrapper || !mainImage) return;

    var thumbBtns = thumbStrip ? thumbStrip.querySelectorAll('[data-src]') : [];
    var currentThumbIndex = 0;
    var isZoomed = false;

    // Thumbnail click → swap main image
    thumbBtns.forEach(function(btn, index) {
      btn.addEventListener('click', function() {
        mainImage.src = btn.getAttribute('data-src');
        mainImage.alt = btn.getAttribute('data-alt') || '';

        // Update active state
        thumbBtns.forEach(function(t) { t.classList.remove('active'); });
        btn.classList.add('active');
        currentThumbIndex = index;
      });
    });

    // Zoom on hover — click toggles, mouse tracks transform-origin
    mainWrapper.addEventListener('click', function() {
      isZoomed = !isZoomed;
      mainWrapper.classList.toggle('zoom-active', isZoomed);
      mainWrapper.classList.toggle('zoomed', isZoomed);
    });

    mainWrapper.addEventListener('mousemove', function(e) {
      if (!isZoomed) return;
      var rect = mainWrapper.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      mainWrapper.style.setProperty('--zoom-x', x + '%');
      mainWrapper.style.setProperty('--zoom-y', y + '%');
    });

    mainWrapper.addEventListener('mouseleave', function() {
      isZoomed = false;
      mainWrapper.classList.remove('zoom-active', 'zoomed');
    });

    // Keyboard arrow navigation for thumbnails
    document.addEventListener('keydown', function(e) {
      if (thumbBtns.length === 0) return;
      var tag = (e.target.tagName || '').toLowerCase();
      if (tag === 'input' || tag === 'textarea' || tag === 'select' || e.target.isContentEditable) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        var dir = e.key === 'ArrowRight' ? 1 : -1;
        currentThumbIndex = Math.max(0, Math.min(thumbBtns.length - 1, currentThumbIndex + dir));
        thumbBtns[currentThumbIndex].click();
        thumbBtns[currentThumbIndex].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    });
  }

  // ── Variant / Size Selector ───────────────────────────────────────────

  function initVariantSelector() {
    var sizeContainer = document.querySelector('[data-variant-selector]');
    if (!sizeContainer) return;

    var sizeBtns = sizeContainer.querySelectorAll('.size-btn');
    var priceEl = document.querySelector('.price-display__current');
    var compareEl = document.querySelector('.price-display__compare');
    var addToCartBtn = document.querySelector('[data-add-to-cart]');

    sizeBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (btn.disabled) return;

        // Update active state
        sizeBtns.forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');

        var variantId = btn.getAttribute('data-variant-id');
        var price = btn.getAttribute('data-price');
        var comparePrice = btn.getAttribute('data-compare-price');

        // Update displayed price
        if (priceEl) priceEl.textContent = price;

        // Update compare-at price
        if (compareEl) {
          if (comparePrice && comparePrice !== '' && comparePrice !== price) {
            compareEl.textContent = comparePrice;
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }

        // Update add to cart button variant ID
        if (addToCartBtn) {
          addToCartBtn.setAttribute('data-variant-id', variantId);
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'Add to Cart';
        }

        // Update URL with variant
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url.toString());
        }

        // Update image to variant's featured image, or first product image as fallback
        if (window.productData) {
          var variants = window.productData.variants || [];
          var newImageSrc = null;
          var newImageAlt = '';

          // Find variant's featured image
          for (var i = 0; i < variants.length; i++) {
            if (String(variants[i].id) === String(variantId)) {
              if (variants[i].featured_image) {
                newImageSrc = variants[i].featured_image.src;
                newImageAlt = variants[i].featured_image.alt || window.productData.title || '';
              }
              break;
            }
          }

          // Fallback: use first product image if variant has no featured image
          if (!newImageSrc && window.productData.images && window.productData.images.length > 0) {
            newImageSrc = window.productData.images[0].src;
            newImageAlt = window.productData.images[0].alt || window.productData.title || '';
          }

          if (newImageSrc) {
            var mainImage = document.getElementById('mainImage');
            if (mainImage) {
              mainImage.src = newImageSrc;
              mainImage.alt = newImageAlt;
            }

            // Sync thumbnail active state
            var thumbStrip = document.getElementById('thumbStrip');
            if (thumbStrip) {
              var thumbBtns = thumbStrip.querySelectorAll('[data-src]');
              thumbBtns.forEach(function(t) {
                t.classList.toggle('active', t.getAttribute('data-src') === newImageSrc);
              });
            }
          }
        }
      });
    });
  }

  // ── Quantity Picker ───────────────────────────────────────────────────

  function initQuantityPicker() {
    var minusBtn = document.querySelector('[data-qty-minus]');
    var plusBtn = document.querySelector('[data-qty-plus]');
    var input = document.querySelector('[data-qty-input]');

    if (!minusBtn || !plusBtn || !input) return;

    minusBtn.addEventListener('click', function() {
      var val = parseInt(input.value, 10) || 1;
      if (val > 1) {
        input.value = val - 1;
      }
    });

    plusBtn.addEventListener('click', function() {
      var val = parseInt(input.value, 10) || 1;
      var max = parseInt(input.getAttribute('max'), 10) || 10;
      if (val < max) {
        input.value = val + 1;
      }
    });

    input.addEventListener('change', function() {
      var val = parseInt(input.value, 10);
      var min = parseInt(input.getAttribute('min'), 10) || 1;
      var max = parseInt(input.getAttribute('max'), 10) || 10;
      if (isNaN(val) || val < min) input.value = min;
      if (val > max) input.value = max;
    });
  }

  // ── Tab Switching ─────────────────────────────────────────────────────

  function initTabs() {
    var tabBar = document.getElementById('tabBar');
    if (!tabBar) return;

    var tabBtns = tabBar.querySelectorAll('[data-tab]');
    var tabPanels = document.querySelectorAll('[data-tab-panel]');

    tabBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var target = btn.getAttribute('data-tab');

        // Update button states
        tabBtns.forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');

        // Update panel visibility
        tabPanels.forEach(function(panel) {
          var panelTab = panel.getAttribute('data-tab-panel');
          if (panelTab === target) {
            panel.classList.add('active');
          } else {
            panel.classList.remove('active');
          }
        });
      });
    });
  }

  // ── Add to Cart (AJAX) ────────────────────────────────────────────────

  function initAddToCart() {
    var addBtn = document.querySelector('[data-add-to-cart]');
    if (!addBtn) return;

    addBtn.addEventListener('click', function(e) {
      e.preventDefault();
      if (addBtn.disabled) return;

      var variantId = addBtn.getAttribute('data-variant-id');
      var qtyInput = document.querySelector('[data-qty-input]');
      var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;

      if (!variantId) return;

      // Disable button during request
      var originalText = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: parseInt(variantId, 10),
          quantity: quantity
        })
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function() {
        // Update cart badge count
        updateCartBadge();

        // Open the slide-out cart drawer (no-op if the snippet is absent)
        if (window.WDCartDrawer) { window.WDCartDrawer.open(); }

        // Success feedback
        addBtn.textContent = 'Added!';
        if (window.wdAnnounce) window.wdAnnounce('Item added to cart');
        setTimeout(function() {
          addBtn.disabled = false;
          addBtn.textContent = originalText;
        }, 2000);
      })
      .catch(function(error) {
        console.error('Add to cart error:', error);
        addBtn.disabled = false;
        addBtn.textContent = originalText;
      });
    });
  }

  function updateCartBadge() {
    fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var badges = document.querySelectorAll('[data-cart-count]');
      badges.forEach(function(badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? '' : 'none';
      });

      // Also try the common .nav__cart-count selector
      var navBadge = document.querySelector('.nav__cart-count');
      if (navBadge) {
        navBadge.textContent = cart.item_count;
        navBadge.style.display = cart.item_count > 0 ? '' : 'none';
      }
    })
    .catch(function() {});
  }

  // ── Product Recommendations (fetch section) ───────────────────────────

  function initRecommendations() {
    var container = document.querySelector('[data-product-recommendations]');
    if (!container) return;

    var url = container.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newContent = doc.querySelector('[data-product-recommendations]');
        if (newContent && newContent.innerHTML.trim()) {
          container.innerHTML = newContent.innerHTML;
        }
      })
      .catch(function() {});
  }

})();
